import { render } from "./MobileProductInfo.vue?vue&type=template&id=4e40af5e"
import script from "./MobileProductInfo.vue?vue&type=script&lang=js"
export * from "./MobileProductInfo.vue?vue&type=script&lang=js"

import "./MobileProductInfo.vue?vue&type=style&index=0&id=4e40af5e&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__